import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/crm/activities')({
  component: ActivitiesLayout,
})

function ActivitiesLayout() {
  return <Outlet />
}
